import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TimeDisplayMode, TimeDisplayService } from '@services/timeDisplay/time-display.service';

@Component({
  selector: 'app-time-display-toggle',
  templateUrl: './time-display-toggle.component.html',
  styleUrls: ['./time-display-toggle.component.scss']
})
export class TimeDisplayToggleComponent implements OnInit {
  @Output() modeChange = new EventEmitter<TimeDisplayMode>();

  public currentMode: TimeDisplayMode = TimeDisplayMode.Clock;

  constructor(
    private timeDisplayService: TimeDisplayService
  ) {}

  ngOnInit(): void {
    // Get the current mode, but only support 'clock' or 'work'
    const savedMode = this.timeDisplayService.getMode();
    this.currentMode = savedMode === TimeDisplayMode.Work ? TimeDisplayMode.Work : TimeDisplayMode.Clock;
  }

  public toggleMode(): void {
    // Toggle between clock and work modes only
    const newMode: TimeDisplayMode = this.currentMode === TimeDisplayMode.Clock
      ? TimeDisplayMode.Work
      : TimeDisplayMode.Clock;
    this.currentMode = newMode;
    this.timeDisplayService.setMode(newMode);
    this.modeChange.emit(newMode);
  }

  public get iconName(): string {
    return this.currentMode === TimeDisplayMode.Clock ? 'time-outline' : 'body-outline';
  }

  public get tooltipText(): string {
    return this.currentMode === TimeDisplayMode.Clock
      ? 'Showing clock time (click for work time)'
      : 'Showing work time (click for clock time)';
  }
}
